




























import { Component, Vue } from "vue-property-decorator";
import Loading from "@/shared/components/loading.vue";
import Modal from "@/shared/components/modal.vue";
import { validDate, required } from "@/shared/validators";
import DatePicker from "@/shared/components/date-picker.vue";
import dayjs from "dayjs";

@Component({
  components: {
    Loading,
    Modal,
    DatePicker,
  },
})
export default class SelectPeriodo extends Vue {
  periodo?: number | null = null;
  campoData1?: boolean = false;
  campoData2?: boolean = false;

  rules = {
    data: [required(), validDate()],
  };

  intervalo = {
    dataInicio: dayjs().format("YYYY-MM-DD"),
    dataFim: "",
  };

  items = [
    { text: "Todos", value: 0 },
    { text: "Hoje", value: 1 },
    { text: "Últimos 7 dias", value: 2 },
    { text: "Últimos 15 dias", value: 3 },
    { text: "Mês atual", value: 4 },
    { text: "Mês passado", value: 5 },
    { text: "Data específica", value: 6 },
    { text: "Período", value: 7 },
  ];

  mounted() {
    this.periodo = 0;
  }

  emitir() {
    this.$emit("onPeriodoChange", this.intervalo);
  }

  changedPeriodo() {
    switch (this.periodo) {
      case 0:
        this.campoData1 = false;
        this.campoData2 = false;
        this.intervalo.dataInicio = "";
        this.intervalo.dataFim = "";
        break;
      case 1:
        this.campoData1 = true;
        this.campoData2 = false;
        this.intervalo.dataInicio = dayjs().format("YYYY-MM-DD");
        break;
      case 2:
        this.campoData1 = true;
        this.campoData2 = true;
        this.intervalo.dataInicio = dayjs()
          .subtract(7, "day")
          .format("YYYY-MM-DD");
        this.intervalo.dataFim = dayjs().format("YYYY-MM-DD");
        break;
      case 3:
        this.campoData1 = true;
        this.campoData2 = true;
        this.intervalo.dataInicio = dayjs()
          .subtract(15, "day")
          .format("YYYY-MM-DD");
        this.intervalo.dataFim = dayjs().format("YYYY-MM-DD");
        break;
      case 4:
        this.campoData1 = true;
        this.campoData2 = true;
        this.intervalo.dataInicio = dayjs()
          .startOf("month")
          .format("YYYY-MM-DD");
        this.intervalo.dataFim = dayjs()
          .endOf("month")
          .format("YYYY-MM-DD");
        break;
      case 5:
        this.campoData1 = true;
        this.campoData2 = true;
        this.intervalo.dataInicio = dayjs()
          .startOf("month")
          .subtract(1, "month")
          .format("YYYY-MM-DD");
        this.intervalo.dataFim = dayjs()
          .subtract(1, "month")
          .endOf("month")
          .format("YYYY-MM-DD");
        break;
      case 6:
        this.campoData1 = true;
        this.campoData2 = false;
        this.intervalo.dataInicio = "";
        this.intervalo.dataFim = "";
        break;
      case 7:
        this.campoData1 = true;
        this.campoData2 = true;
        this.intervalo.dataInicio = "";
        this.intervalo.dataFim = "";
        break;
    }
    this.emitir();
  }
}
